module.exports = __webpack_public_path__ + "img/pip1.7d9e16da.jpg";